//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FooterComponent from "../components/common/FooterComponent";
import HeaderComponent from "../components/common/HeaderComponent";

export default {
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      bootstrapData: null,
      globalModal: null,
      showGlobalModalVar: false,
      password_recovery_token: null,
    }
  },
  async fetch() {
    const { store, $axios } = this.$nuxt.context;
    await $axios.get('/bootstrap')
      .then(res => {
        this.bootstrapData = res.data;
        store.commit('setBootstrap', res.data);
      })
      .catch(err => {
        store.commit('setBootstrap', null)
      })
    // store.dispatch('getCart');
  },
  methods: {
    showGlobalModal(e) {
      this.globalModal = e;
      this.showGlobalModalVar = true;
    },
    footerAlign() {
      if (document.querySelector('#footer')) {
        document.querySelector('#footer').style.display = 'block';
        document.querySelector('#footer').style.height = 'auto';
        const footerHeight = document.querySelector('#footer')?.clientHeight || 0;
        if (!this.$route.path.includes('/checkout') && !this.$route.path.includes('/thank-you') && !this.$route.path.includes('/profile')) {
          document.querySelector('.v-main__wrap').style.paddingBottom = `${footerHeight}px`;
        } else {
          document.querySelector('.v-main__wrap').style.paddingBottom = `0px`;
          document.querySelector('#footer').style.height = '0px';
        }
        // document.querySelector('#footer').style.paddingBottom = `${footerHeight}px`;
      } else {
        document.querySelector('.v-main__wrap').style.paddingBottom = `0px`;
      }
    },
    setKlaviyoFormListener() {
      window.addEventListener("klaviyoForms", (e) => {
        if (e.detail?.formId === 'XSwwkB' && e.detail?.type === 'submit') {
          fbq('track', 'Lead');
        }
      });
    },
    imagesSizeResolve() {
      window.imageResolver = new com.liquidpixels.Resolve({
        server: this.$config.CDN_OPTIMIZE_DOMEN,
        uri: this.$config.CDN_OPTIMIZE_URI,
        imageFit: "containerWidth", // container, containerWidth, containerHeight, containerFill, stretch, containerMax, containerPad
        // authSecret: "",
        // base: "",
        lazyLoad: true,
        output: function(browser, image) {
        	return {
        		// format: ["webp", "jpg"], //Array/String,
        		quality: {
        			// webp: 75,
        			// jpg: 70,
              png: 100,
        			default: browser.platform.type?.match(/mobile/) ? 70 : 80 // Default 80
        		}, //Number/String/Object
        		// expires: "+1 week", // String/Number
        		// pixelRatio: browser.platform.type?.match(/mobile/) ? 1 : undefined // Number (integer), default undefined, window.devicePixelRatio (not work with float value)
        	};
        },
        advancedOptions: {
          // runOnPageLoad: true,
          // responsive: true,
          // pageResizeDelay: 200,
          // overridePixelRatio: undefined,
          // maxPixelRatio: undefined
          cacheThreshold: 200, // default 100
          // allowImageUpscaling: false,
          // enabledClass: "Resolve",
          // completedClass: "ResolveComplete",
          // errorClass: "ResolveError",
          // ignoreGIF: false,
          // expires: "+2 minute", // Default value undefined === Cache-Control: max-age=3600 (maximum 3600)
          // alwaysUseSSL: false,
          // neverUseSSL: false,
          // preloadImage: true
        },
        // handleEvent: function(type, data) {
        //   console.log("[%o]: %o", type, data);
        // }
      });
    }
  },
  computed: {
    bootstrap() {
      return this.$store.getters.getBootstrap;
    }
  },
  created() {
    this.$root.$on('showGlobalModal', this.showGlobalModal)
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.footerAlign();
      })
    },
    bootstrap() {
      this.footerAlign();
    }
  },
  beforeMount() {
    if (this.$config.CDN_OPTIMIZE_DOMEN && !window.imageResolver) {
      this.imagesSizeResolve();
    }
    this.$store.commit('setBootstrap', this.bootstrapData);
    if (this.$route.path !== '/cart' && !this.$route.query.on) {
      this.$store.dispatch('getCart');
    }

  },
  mounted() {
    this.setKlaviyoFormListener();
    setTimeout(() => {
      if (this.bootstrap) {
        this.footerAlign();
      }
    }, 0);
    window.addEventListener('resize', () => {
      if (this.bootstrap) {
        this.footerAlign();
      }
    })
    /*const params = {
      email_verification_token: this.$route.params.token
    }
    this.$axios.post('/users/change-password', params)
      .then(res => {
        this.$router.push('/');
        const e = {
          type: 'success',
          text: this.$t('emailVerifySuccess')
        }
        this.$root.$emit('showGlobalModal', e)
      })
      .catch(err => {
        this.$router.push('/');
        const e = {
          type: 'error',
          text: err.response.data.errors[0].message
        }
        this.$root.$emit('showGlobalModal', e)
      })*/
  }
}
